<template>
    <div>
        <div class="columns is-mobile is-multiline">
            <div class="column is-half-mobile is-half-tablet is-one-third-desktop">
                <figure class="image is-1by1">
                    <img class="gallery-image" :src="selection[0]" @click="imageIndex = 0">
                </figure>
            </div>
            <div class="column is-half-mobile is-half-tablet is-one-third-desktop">
                <figure class="image is-1by1">
                    <img class="gallery-image" :src="selection[1]" @click="imageIndex = 1">
                </figure>
            </div>
            <div class="column is-half-mobile is-half-tablet is-one-third-desktop">
                <figure class="image is-1by1">
                    <img class="gallery-image" :src="selection[2]" @click="imageIndex = 2">
                </figure>
            </div>
            <div class="column is-half-mobile is-half-tablet is-one-third-desktop">
                <figure class="image is-1by1">
                    <img class="gallery-image" :src="selection[3]" @click="imageIndex = 3">
                </figure>
            </div>
            <div class="column is-half-mobile is-half-tablet is-one-third-desktop">
                <figure class="image is-1by1">
                    <img class="gallery-image" :src="selection[4]" @click="imageIndex = 4">
                </figure>
            </div>
            <div class="column is-half-mobile is-half-tablet is-one-third-desktop">
                <figure class="image is-1by1">
                    <img class="gallery-image" :src="selection[5]" @click="imageIndex = 5">
                </figure>
            </div>
            <div class="column is-half-mobile is-half-tablet is-one-third-desktop">
                <figure class="image is-1by1">
                    <img class="gallery-image" :src="selection[6]" @click="imageIndex = 6">
                </figure>
            </div>
            <div class="column is-half-mobile is-half-tablet is-one-third-desktop">
                <figure class="image is-1by1">
                    <img class="gallery-image" :src="selection[7]" @click="imageIndex = 7">
                </figure>
            </div>
            <div class="column is-half-mobile is-half-tablet is-one-third-desktop">
                <figure class="image is-1by1">
                    <img class="gallery-image" :src="selection[8]" @click="imageIndex = 8">
                </figure>
            </div>
        </div>
        <div class="columns is-mobile is-centered">
            <router-link to="/photo" class="is-page-read-more">Meer foto's!</router-link>
        </div>
        <!-- <template> -->
            <!-- <div> -->
                <vue-gallery class="back" :images="selection" :index="imageIndex" @close="imageIndex = null"></vue-gallery>
            <!-- </div> -->
        <!-- </template> -->
    </div>
</template>

<script>
    import axios from 'axios';
    import VueGallery from "vue-gallery";

    export default {
      name: "Gallery",
      components: {
          VueGallery
      },
      data: function() {
        return {
          source: [],
          selection: [],
          imageIndex: null
        }
      },
      mounted: function() {
        axios.get(process.env.VUE_APP_IMAGES_URL + '/collection/index.json').then(indexJson => {
          indexJson.data.forEach(imageJson => {
            this.source.push(process.env.VUE_APP_IMAGES_URL + imageJson.location);
          });
          let collectionSize = this.source.length;

          // Select 9 random pictures
          for (let i = 0; i < 9; i++) {
            // Add the random picture to the selection and remove from source
            let next = Math.floor((Math.random() * (collectionSize - i)));
            this.selection.push(this.source[next]);
            this.source.splice(next, 1);
          }
        });
      }
    }
</script>

<style scoped>
    .gallery-image {
        object-fit: cover;
    }
    .gallery-image:hover {
        cursor: pointer;
    }
    .back {
        z-index: -1;
    }
    .is-on-last-row {
        margin-bottom: 0;
    }
</style>